"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSdk = exports.TrackEventDocument = exports.ProfileDocument = exports.MarketplaceSettingsDocument = exports.ListConnectionsDocument = exports.GetConnectionByIndexDocument = exports.AddShareDocument = void 0;
exports.AddShareDocument = `
    mutation addShare($input: ShareInput!) {
  addShare(input: $input) {
    short_url
    target_path
    endpoint
    service
    expiration
  }
}
    `;
exports.GetConnectionByIndexDocument = `
    query getConnectionByIndex($index: Int!) {
  connection: getConnectionByIndex(index: $index) {
    id
    index
    cloud {
      id
    }
    dashboard
    name
    username
    endpoint
    token
    isStardogCloud
    isStardogFree
    isAllocating
    useBrowserAuth
    useSSO
  }
}
    `;
exports.ListConnectionsDocument = `
    query listConnections {
  listConnections {
    id
    index
    cloud {
      id
    }
    dashboard
    name
    username
    endpoint
    token
    isStardogCloud
    isStardogFree
    isAllocating
    useBrowserAuth
    useSSO
  }
}
    `;
exports.MarketplaceSettingsDocument = `
    query marketplaceSettings {
  marketplaceSettings {
    marketplaceUsername
    marketplacePassword
    marketplaceEndpoint
    marketplaceDatabase
  }
}
    `;
exports.ProfileDocument = `
    query profile {
  profile {
    id
    username
    email
    first_name
    last_name
    company
    use_case
    is_authenticated
    is_staff
    is_superuser
    userflow_signature
    date_joined
    is_voicebox_enabled
    is_static_voicebox
  }
}
    `;
exports.TrackEventDocument = `
    mutation trackEvent($input: TrackEventInput!) {
  trackEvent(input: $input) {
    success
    error
  }
}
    `;
const defaultWrapper = (action, _operationName, _operationType) => action();
function getSdk(client, withWrapper = defaultWrapper) {
    return {
        addShare(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.AddShareDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'addShare', 'mutation');
        },
        getConnectionByIndex(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.GetConnectionByIndexDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'getConnectionByIndex', 'query');
        },
        listConnections(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.ListConnectionsDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'listConnections', 'query');
        },
        marketplaceSettings(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.MarketplaceSettingsDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'marketplaceSettings', 'query');
        },
        profile(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.ProfileDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'profile', 'query');
        },
        trackEvent(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.TrackEventDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'trackEvent', 'mutation');
        },
    };
}
exports.getSdk = getSdk;
